var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCluster56 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 7,
  width: 42,
  height: 42,
  rx: 21,
  fill: "#FF617E"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 3.5,
  y: 3.5,
  width: 49,
  height: 49,
  rx: 24.5,
  stroke: "#FF617E",
  strokeOpacity: 0.4,
  strokeWidth: 7
})));
export { SvgCluster56 as ReactComponent };
export default __webpack_public_path__ + "25cff0264539d5018ae67244ed74a204.svg";